<template>
  
</template>

<script>
  module.exports = {
    ready: function () {
    },
    data: function () {
      return {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Blank.vue?3c0ffeb9